import { DataActiveStatusEnum } from "../../Category/types";
import {
  IData,
  SubCategoryState,
  TypeEnum,
} from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  title: "",
  categoryId: "",
  status: DataActiveStatusEnum.ACTIVE,
  type: TypeEnum.Null,
  featuredImage: "",
  categoryTitle: "",
  sortOrder: 0,
};

export const initialState: SubCategoryState = {
  formData: { ...defaultFormData },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  allGroupList: []
};
